import { ControlMeasure, RiskAssessmentItem } from "../../../../models/risk-assessment.interface";
import styles from "./risk-item.module.css";
import { Divider } from "primereact/divider";
import React from "react";
import useApiService from "../../../../hooks/useApiService";
import { Appointment } from "../../../../models/appointment.interface";
import { formatDate } from "../../../../utils/DateUtils";
import { SelectButton } from "primereact/selectbutton";

interface RiskItemProps {
  item: RiskAssessmentItem;
}

export function RiskItem({ item }: RiskItemProps) {
  console.log("item", item);
  const { data: appointments } = useApiService<Appointment[]>({
    url: "appointments",
    method: "GET",
    apiName: "core",
  });

  const likelihoodOptions = [
    {
      value: 1,
      label: "Rare",
      color: "#2DD55B",
    },
    {
      value: 2,
      label: "Unlikely",
      color: "#53A048",
    },
    {
      value: 3,
      label: "Possible",
      color: "#796B35",
    },
    {
      value: 4,
      label: "Likely",
      color: "#9F3522",
    },
    {
      value: 5,
      label: "Almost Certain",
      color: "#C5000F",
    },
  ];
  const afterLikelihoodOptions = [
    {
      value: 1,
      label: "Rare",
      color: "#2DD55B",
      selected: false,
    },
    {
      value: 2,
      label: "Unlikely",
      color: "#53A048",
      selected: false,
    },
    {
      value: 3,
      label: "Possible",
      color: "#796B35",
      selected: false,
    },
    {
      value: 4,
      label: "Likely",
      color: "#9F3522",
      selected: false,
    },
    {
      value: 5,
      label: "Almost Certain",
      color: "#C5000F",
      selected: false,
    },
  ];

  const consequenceOptions = [
    {
      value: 1,
      label: "Minor",
      color: "#2DD55B",
    },
    {
      value: 2,
      label: "Moderate",
      color: "#53A048",
    },
    {
      value: 3,
      label: "Serious",
      color: "#796B35",
    },
    {
      value: 4,
      label: "Major",
      color: "#9F3522",
    },
    {
      value: 5,
      label: "Catastrophic ",
      color: "#C5000F",
    },
  ];

  const afterConsequenceOptions = [
    {
      value: 1,
      label: "Minor",
      color: "#2DD55B",
      selected: false,
    },
    {
      value: 2,
      label: "Moderate",
      color: "#53A048",
      selected: false,
    },
    {
      value: 3,
      label: "Serious",
      color: "#796B35",
      selected: false,
    },
    {
      value: 4,
      label: "Major",
      color: "#9F3522",
      selected: false,
    },
    {
      value: 5,
      label: "Catastrophic ",
      color: "#C5000F",
      selected: false,
    },
  ];

  const ratingOptions = [
    {
      value: 1,
      label: "Low Risk",
      color: "#2DD55B",
    },
    {
      value: 2,
      label: "Possible Risk",
      color: "#53A048",
    },
    {
      value: 3,
      label: "Medium Risk",
      color: "#796B35",
    },
    {
      value: 4,
      label: "High Risk",
      color: "#9F3522",
    },
    {
      value: 5,
      label: "Critical Risk",
      color: "#C5000F",
    },
  ];

  const afterRatingOptions = [
    {
      value: 1,
      label: "Low Risk",
      color: "#2DD55B",
      selected: false,
    },
    {
      value: 2,
      label: "Possible Risk",
      color: "#53A048",
      selected: false,
    },
    {
      value: 3,
      label: "Medium Risk",
      color: "#796B35",
      selected: false,
    },
    {
      value: 4,
      label: "High Risk",
      color: "#9F3522",
      selected: false,
    },
    {
      value: 5,
      label: "Critical Risk",
      color: "#C5000F",
      selected: false,
    },
  ];

  const justifyTemplate = (option: any) => {
    return (
      <div>
        <label style={{ color: option.color }}>{option.label}</label>
        {option.selected ? (
          <label
            style={{
              position: "absolute",
              top: "0",
              right: "5px",
              color: "red",
              fontSize: "x-large",
            }}
          >
            *
          </label>
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <div>
      <p className={styles["divider"]}>Details</p>
      <div className={styles["key-value"]}>
        <p>Hazard</p>
        <p>{item.hazard_list}</p>
      </div>
      <div className={styles["key-value"]}>
        <p>Risk outcome (description)</p>
        <p>{item.description}</p>
      </div>
      <div className={styles["key-value"]}>
        <p>Responsible</p>
        <p>{appointments?.find(appointment => appointment.id === item.responsible)?.name}</p>
      </div>
      <div className={styles["key-value"]}>
        <p>Review date</p>
        <p>{formatDate(item.review_date)}</p>
      </div>
      <p className={styles["divider"]}>Type</p>
      <div className={styles["key-value"]}>
        <p>Typee</p>
        <p>{item.type}</p>
      </div>
      <p className={styles["divider"]}>Risk score</p>
      <span className={styles["label"]}>Likelihood</span>
      <SelectButton
        value={item.likelihood}
        onChange={(e: any) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        itemTemplate={justifyTemplate}
        options={likelihoodOptions}
        optionLabel="label"
        optionValue="value"
      />
      <div style={{ marginTop: "1rem" }}>
        <span className={styles["label"]}>Consequence</span>
        <SelectButton
          value={item.consequence}
          onChange={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          itemTemplate={justifyTemplate}
          options={consequenceOptions}
          optionLabel="label"
          optionValue="value"
        />
      </div>
      <div style={{ marginTop: "1rem" }}>
        <span className={styles["label"]}>Rating</span>
        <SelectButton
          value={item.rating}
          onChange={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          itemTemplate={justifyTemplate}
          options={ratingOptions}
          optionLabel="label"
          optionValue="value"
        />
      </div>
      <p className={styles["divider"]}>Control Measure</p>
      {item.control_measures && item.control_measures.length > 0 ? (
        <>
          {item.control_measures.map((control_measure: ControlMeasure, index: number) => {
            return (
              <div key={index} className={styles["key-value"]}>
                <p>Control measure</p>
                <p>{control_measure.name}</p>
              </div>
            );
          })}
        </>
      ) : (
        <div style={{ fontWeight: 600 }}>No control measures on the risk item.</div>
      )}
      <p className={styles["divider"]}>After Control Risk Score</p>
      <span className={styles["label"]}>After Control Risk Likelihood</span>
      <SelectButton
        value={item.likelihood}
        onChange={(e: any) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        itemTemplate={justifyTemplate}
        options={afterLikelihoodOptions}
        optionLabel="label"
        optionValue="value"
      />
      <div style={{ marginTop: "1rem" }}>
        <span className={styles["label"]}>After Control Risk Consequence</span>
        <SelectButton
          value={item.consequence}
          onChange={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          itemTemplate={justifyTemplate}
          options={afterConsequenceOptions}
          optionLabel="label"
          optionValue="value"
        />
      </div>
      <div style={{ marginTop: "1rem" }}>
        <span className={styles["label"]}>After Control Risk Rating</span>
        <SelectButton
          value={item.rating}
          onChange={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          itemTemplate={justifyTemplate}
          options={afterRatingOptions}
          optionLabel="label"
          optionValue="value"
        />
      </div>
    </div>
  );
}
